import React, { useState, useEffect } from "react";
import { useSignalRStatusNotification } from "./useSignalR";
import WorkflowRunStatusIcon from '../../icons/WorkflowRunStatusIcon.js';
import "./index.css";

// Component to display status feed notifications
// Helpful for showing real-time updates from the server during testing
export default function StatusFeed() {
  const [statusFeed, setStatusFeed] = useState(null);
  const [showNotification, setShowNotification] = useState(false);

  useSignalRStatusNotification((message) => {
    setStatusFeed(message);
    setShowNotification(true);
    console.log("Received status update:", message);
  });

  useEffect(() => {
    if (showNotification && statusFeed) {
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 10000); // Hide after 10 seconds

      return () => clearTimeout(timer);
    }
  }, [showNotification, statusFeed]);

  const handleClose = () => {
    setShowNotification(false);
  };
  const getMessageContent = (statusFeed) => {
    if (!statusFeed) return null;
    switch (statusFeed.Status.toUpperCase()) {
      case "SUCCESS":
        return `The workflow run '${statusFeed.WorkflowName}' completed successfully.`;
      case "WARNING":
        return `The workflow run '${statusFeed.WorkflowName}' completed with warnings.`;
      case "FAILED":
        return `The workflow run '${statusFeed.WorkflowName}' failed.`;
      default:
        return null;
    }
  };

  return (
    <>
      {showNotification && statusFeed && (
        <div className="status-notification-popup">
          <div className="status-notification-content">
            <button 
              className="status-notification-close" 
              onClick={handleClose}
              aria-label="Close notification"
            >
              ×
            </button>
            <h3 className="status-notification-title">Workflow Runs Notification</h3>
            <p className="status-notification-message">
              <WorkflowRunStatusIcon status={statusFeed.Status.toUpperCase()}>
                {getMessageContent(statusFeed)}
              </WorkflowRunStatusIcon>
            </p>
          </div>
        </div>
      )}
    </>
  );
}
